
import { CalendarReturnsTable } from "./CalendarReturnsTable";
import { Separator } from "@/components/ui/separator";

interface Performance {
  date: string;
  performance_value: number;
  frequency: string;
}

interface FundReturnsProps {
  performance: Performance[];
}

export function FundReturns({ performance }: FundReturnsProps) {
  return (
    <>
      <Separator />
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Calendar Returns</h2>
        <CalendarReturnsTable performance={performance} />
      </div>
    </>
  );
}
